import React from "react";
import video from "../../assets/videos/journey.mp4";

export default function LearnMore() {
  return (
    <section className="relative w-full h-screen overflow-hidden">
      {/* Pattern overlay */}
      <div
        className="absolute inset-0"
        style={{
          backgroundSize: "16px 16px",
          backgroundImage:
            "repeating-linear-gradient(45deg, rgba(180,180,180,0.8) 0, rgba(180,180,180,0.8) 1px, rgba(255,255,255,0.2) 0, rgba(255,255,255,0.2) 50%)",
          border: "1px solid #c4c4c4",
        }}
      />

      {/* Video background */}
      <video
        src={video}
        loop
        muted
        autoPlay
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Blur overlay */}
      <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" />

      {/* Decorative circle + lines */}
      <div className="absolute top-16 left-1/2 transform -translate-x-1/2 flex items-center space-x-4 z-10">
        <div className="h-[1px] w-12 sm:w-16 bg-white" />
        <div className="rounded-full border border-white w-4 sm:w-6 h-4 sm:h-6" />
        <div className="h-[1px] w-12 sm:w-16 bg-white" />
      </div>

      {/* Content */}
      <div className="relative z-20 flex flex-col items-center justify-center h-full text-center px-4 sm:px-6 md:px-12">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-white mb-4">
          Luxury mountaineering & trekking experiences
        </h2>

        {/* Large background text */}
        <h3 className="text-[50px] sm:text-[80px] md:text-[120px] lg:text-[200px] font-bold text-gray-300/20 leading-none select-none pointer-events-none mb-6">
          Believe Begin Achieve
        </h3>

        <a
          href="./about"
          className="px-6 sm:px-8 py-2 sm:py-3 rounded-full border border-white text-white font-medium hover:bg-gray-800 hover:text-white transition text-sm sm:text-base"
        >
          LEARN MORE
        </a>
      </div>
    </section>
  );
}
